import { render, staticRenderFns } from "./ScanForBJWL.vue?vue&type=template&id=0893e772&scoped=true"
import script from "./ScanForBJWL.vue?vue&type=script&lang=js"
export * from "./ScanForBJWL.vue?vue&type=script&lang=js"
import style0 from "./ScanForBJWL.vue?vue&type=style&index=0&id=0893e772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0893e772",
  null
  
)

export default component.exports